export const leadConstants = {
    GET_ALL_LEADS_REQUEST: 'GET_ALL_LEADS_REQUEST',
    GET_ALL_LEADS_SUCCESS: 'GET_ALL_LEADS_SUCCESS',
    GET_ALL_LEADS_FAILURE: 'GET_ALL_LEADS_FAILURE',

    UPDATE_LEAD_REQUEST: 'UPDATE_LEAD_REQUEST',
    UPDATE_LEAD_SUCCESS: 'UPDATE_LEAD_SUCCESS',
    UPDATE_LEAD_FAILURE: 'UPDATE_LEAD_FAILURE',

    DELETE_LEAD_REQUEST: 'DELETE_LEAD_REQUEST',
    DELETE_LEAD_SUCCESS: 'DELETE_LEAD_SUCCESS',
    DELETE_LEAD_FAILURE: 'DELETE_LEAD_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/lead.js